// Source: app/scripts/controllers/page-content.js
Auction.controller('ActivePageContentController', [
  '$scope',
  'Page',
  '$rootScope',
  function($scope, Page, $rootScope) {

    function load(id) {
      console.log('loading: ' + id)
      Page.findPageContent({
        id: id
      }, function(data) {
        if(data) {
          $scope.activePageContent = data.content;
        }else{
          console.log('not loading: ' + id);
        }
      });
    }

    if(!$rootScope.activePage) {
      var unreg = $rootScope.$watch('activePage', function(n) {
        if(n && n.id) {
          load(n.id);
          unreg();
        }
      });
      console.log('!$rootScope.activePage ');
    } else {
      load($rootScope.activePage.id);
      console.log(' else !$rootScope.activePage ');
    }

  }
]);
